<template>
  <div class="labelLayout">
    <div class="labelLayout__top">
      <div class="top_left">
        <slot name="left"></slot>
      </div>
      <div class="top_right">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="labelLayout__bottom">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LabelLayout"
};
</script>

<style lang="less" scoped>
.labelLayout {
  .labelLayout__top {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 41px;
    letter-spacing: 0px;
    color: #999999;
    margin: 0 25px;
  }
  .labelLayout__bottom {
    display: flex;
    justify-content: center;
  }
}
</style>
